function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "car"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m19 11h-.117l-.643-5.14c-.201-1.604-1.624-2.86-3.24-2.86h-6c-1.616 0-3.039 1.256-3.24 2.86l-.643 5.14h-.117c-1.654 0-3 1.346-3 3v2c0 1.302.839 2.401 2 2.815v1.185c0 .553.447 1 1 1s1-.447 1-1v-1h12v1c0 .553.447 1 1 1s1-.447 1-1v-1.185c1.161-.414 2-1.514 2-2.815v-2c0-1.654-1.346-3-3-3zm-11.256-4.892c.074-.59.661-1.108 1.256-1.108h6c.595 0 1.182.518 1.256 1.108l.611 4.892h-9.734zm12.256 9.892c0 .552-.448 1-1 1h-14c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1h14c.552 0 1 .448 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15 14h-6c-.553 0-1 .447-1 1s.447 1 1 1h6c.553 0 1-.447 1-1s-.447-1-1-1z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 15,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 15,
  r: 1
})));

var Svg024Car = function Svg024Car(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg024Car, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/024-car.a363b675.svg";
export { ForwardRef as ReactComponent };